import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { isUseCase } from '@/lib/utils'
import { userActionsQuery } from '@/queries/user-actions.query'

export const Route = createFileRoute('/_dashboard/my-actions/')({
  loader({ context }) {
    return context.queryClient.ensureQueryData(userActionsQuery)
  },
  pendingComponent: PendingComponent,
  beforeLoad({ context }) {
    if (!isUseCase(UseCase.LEGIONELLA)) {
      throw redirect({ to: '/403', search: { reason: 'wrongUseCase' } })
    }

    if (!context.user?.hasPermission(Permission.MY_ACTIONS)) {
      throw redirect({ to: '/403' })
    }
  },
})
